export default "__VITE_ASSET__BiKFf4PY__"